import styled from '@emotion/styled';
import { memo } from 'react';

import responsiveBackgroundImage from '../../lib/responsiveBackgroundImage';
import zIndices from '../../lib/zIndices';

import type { ThemeProps } from '@emotion/react';
import type { CSSObject } from '@emotion/styled';
import type { ResponsiveBackgroundImageProps } from '../../lib/responsiveBackgroundImage';

interface BackgroundProps {
  offsetBackgroundForNavBar?: boolean | undefined;
}

const Background = styled("div")`
  ${(props: ThemeProps): string => {
    const options: ResponsiveBackgroundImageProps = {
      url: props.theme.images.background,
      responsiveImages: props.theme.responsiveImages?.background,
      sm: 800,
      md: 1200,
      lg: 1600,
      xl: 2000,
    };

    return responsiveBackgroundImage(options);
  }}

  background-color: ${(props: ThemeProps): string =>
    props.theme.colors.background};
  background-position: top center;
  background-repeat: no-repeat;
  background-size: cover;
  bottom: 0;
  left: 0;
  position: fixed;
  right: 0;
  z-index: ${zIndices.background};

  // Mobile only: Shift background down from behind mobile nav bar
  ${(props: BackgroundProps): string =>
    props.offsetBackgroundForNavBar
      ? 'top: 56px;' /* height of the mobile nav bar */
      : 'top: 0;'}
  @media (min-width: 768px) {
    top: 0;
  }

  // bug fix for safari mobile: missing background color when bottom action bar is hidden on scroll
  bottom: -120px;

  ${(props: ThemeProps): CSSObject | undefined =>
    props.theme.components.BackgroundImage}
`;

export default memo(Background);
